export default __webpack_public_path__ + "static/media/commentarylogo-trimmed.91249de1.png";